import GatewayIframe from "./GatewayIframe";
import { useGatewayFrame } from "../../lib/use-gateway-frame";
import styles from "./RecentUse.module.css";

interface Props {
  /** The server's URL from the MCP registry. The gateway matches it on its path. */
  serverUrl: string;
  serverTitle: string;
}

/**
 * "Your recent use" in an MCP server page's sidebar (#939, Feature H): which clients last used
 * the server, when, and whether the stored sign-in needs renewing. It is the gateway's own page,
 * framed. It shows only when there is something to show: nothing for a server the person has
 * never used, a failed load, or a gateway that doesn't answer (including a signed-out person,
 * who can sign in from My Connections), so the page reads as it did without it.
 */
export default function RecentUse({ serverUrl, serverTitle }: Props) {
  const frame = useGatewayFrame("recent", serverUrl);
  const { phase } = frame.state;
  if (!frame.src || phase === "error" || phase === "no-response") return null;
  const visible = phase === "ready" && !frame.state.empty;
  if (phase === "ready" && !visible) return null;

  return (
    <section aria-label={`Your recent use of ${serverTitle}`} className={visible ? styles.box : styles.pending}>
      <GatewayIframe frame={frame} title={`Your recent use of ${serverTitle}`} visible={visible} initialHeight={120} />
    </section>
  );
}
